/* eslint-disable max-len */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Brain from '../assets/results/result-brain.png';
import {
  getResults, getResponses, speak, beelineText,
} from '../actions';
import PositiveBrain from '../assets/results/positive_brain.svg';
import NegativeBrain from '../assets/results/negative_brain.svg';
import Buckets from './Buckets';

class Results extends Component {
  componentDidMount() {
    this.props.getResults(this.props.userid, this.props.survey.id);
    this.props.getResponses(this.props.userid, this.props.survey.id);
    this.props.beelineText();
  }

  componentDidUpdate() {
    this.props.beelineText();
  }

  renderPositives = () => {
    const header = (
      <div className="insight-header-container">
        <img src={PositiveBrain} alt="positive-brain" />
        <p onClick={this.props.speak} className={`color insight-header-text result-text ${this.props.speechEnabled && 'bolded'} color`}>The results of the tool show that you feel you’re doing well at:</p>
      </div>
    );
    if (this.props.positiveResponses && this.props.positiveResponses.length !== 0) {
      const bullets = this.props.positiveResponses.map((response, i) => {
        const key = i + 1;
        return (
          <p key={key} onClick={this.props.speak} className={`color insight-text result-text ${this.props.speechEnabled && 'bolded'} color`}>
            <span>&#9679;</span>
            {response.general_result}
          </p>
        );
      });
      return (
        <div>
          {header}
          {bullets}
          <p onClick={this.props.speak} className={`color insight-footer ${this.props.speechEnabled && 'bolded'} color`}>Keep doing these to reach your potential!</p>
        </div>
      );
    } else {
      return (
        <div>
          {header}
          <p onClick={this.props.speak} className={`color result-text empty-insights-text ${this.props.speechEnabled && 'bolded'} color`}>Keep working on your areas of improvement, and you&apos;ll be getting strengths before you know it!</p>
        </div>
      );
    }
  }

  renderNegatives = () => {
    const header = (
      <div className="insight-header-container">
        <img src={NegativeBrain} alt="negative-brain" />
        <p onClick={this.props.speak} className={`color insight-header-text result-text ${this.props.speechEnabled && 'bolded'} color`}>There are the areas where your frontal lobes could use a little support:</p>
      </div>
    );

    if (this.props.negativeResponses && this.props.negativeResponses.length !== 0) {
      const bullets = this.props.negativeResponses.map((response, i) => {
        const key = i + 1;
        return (
          <p key={key} onClick={this.props.speak} className={`color insight-text result-text ${this.props.speechEnabled && 'bolded'} color`}>
            <span>&#9679;</span>
            {response.general_result}
          </p>
        );
      });
      return (
        <div>
          {header}
          {bullets}
        </div>
      );
    } else {
      return (
        <div>
          {header}
          <p onClick={this.props.speak} className={`color result-text empty-insights-text ${this.props.speechEnabled && 'bolded'} color`}>Look&apos;s like you do not have any major weaknesses! Keep doing you!</p>
        </div>
      );
    }
  }

  render() {
    return (
      <div id={this.props.survey.name}>
        <p id="ybe" onClick={this.props.speak} className={`result-subheader result-text ${this.props.speechEnabled && 'bolded'} color`}>Your Brain: Explained</p>
        <div className="box ybe-box">
          <img src={Brain} alt="brain" />
          <p onClick={this.props.speak} className={`result-text ${this.props.speechEnabled && 'bolded'} color`}>{this.props.survey.openingStatement}</p>
        </div>
        <p id="insights" onClick={this.props.speak} className={`result-subheader result-text ${this.props.speechEnabled && 'bolded'} color`}>Insights</p>
        <div className="insight-container">
          <div className="box insight-box">
            {this.renderPositives()}
          </div>
          <div className="box insight-box">
            {this.renderNegatives()}
          </div>
        </div>
        <p id="tools" onClick={this.props.speak} className={`result-subheader result-text ${this.props.speechEnabled && 'bolded'} color`}>
          Toolkit Resources
        </p>
        <Buckets
          buckets={this.props.buckets}
          pdfName={this.props.survey.name}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => (
  {
    userid: state.user.userid,
    buckets: state.result.buckets,
    positiveResponses: state.response.positiveResponses,
    negativeResponses: state.response.negativeResponses,
    speechEnabled: state.speech.enabled,
  }
);

export default connect(mapStateToProps, {
  getResults, getResponses, speak, beelineText,
})(withRouter(Results));
